export interface ViewportTransform {
  scale: number;
  translateX: number;
  translateY: number;
}

export const MIN_MERMAID_ZOOM_SCALE = 0.5;
export const MAX_MERMAID_ZOOM_SCALE = 4;

export const clampScale = (value: number) =>
  Math.min(MAX_MERMAID_ZOOM_SCALE, Math.max(MIN_MERMAID_ZOOM_SCALE, value));

export const zoomAtPoint = (
  transform: ViewportTransform,
  point: { x: number; y: number },
  nextScale: number,
): ViewportTransform => {
  const scaleRatio = nextScale / transform.scale;

  return {
    scale: nextScale,
    translateX: point.x - (point.x - transform.translateX) * scaleRatio,
    translateY: point.y - (point.y - transform.translateY) * scaleRatio,
  };
};

export const measureSvgRenderedSize = (svg: SVGSVGElement, currentScale: number) => {
  const rect = svg.getBoundingClientRect();
  if (rect.width > 0 && rect.height > 0 && currentScale > 0) {
    return { width: rect.width / currentScale, height: rect.height / currentScale };
  }

  const viewBox = svg.viewBox?.baseVal;
  if (viewBox && viewBox.width > 0 && viewBox.height > 0) {
    return { width: viewBox.width, height: viewBox.height };
  }

  return null;
};

export const computeFitTransform = (
  canvas: HTMLElement,
  content: HTMLElement,
  currentScale: number,
): ViewportTransform | null => {
  const svg = content.querySelector("svg");
  if (!svg) {
    return null;
  }

  const contentSize = measureSvgRenderedSize(svg, currentScale);
  if (!contentSize) {
    return null;
  }

  const availableWidth = canvas.clientWidth;
  const availableHeight = canvas.clientHeight;
  if (availableWidth <= 0 || availableHeight <= 0) {
    return null;
  }

  const scale = Math.min(
    1,
    availableWidth / contentSize.width,
    availableHeight / contentSize.height,
  );

  return {
    scale,
    translateX: (availableWidth - contentSize.width * scale) / 2,
    translateY: (availableHeight - contentSize.height * scale) / 2,
  };
};
